import React, { FC, useContext, useEffect, useState } from 'react'
import { AppStateContext } from '@components/layouts/DynamicLayout'
import { formatStrapiText } from '@utils/methods'
import * as pageUtils from './__index.utils'
import Collapse from '@components/ui/collapse'
import { joinClasses } from '@utils/styles'
import { accueilDarkBlueV2 } from '@images/icons'
import { Icon } from '@components/ui/Icon'
import Text from '@components/ui/text'
import Link from '@components/ui/link'
import Loader from '@components/ui/loader'
import { Request } from '@services/models'
import { navigate } from '@components/ui/link'
import config from '@utils/config'
import { getAddressByCoordinates } from '@components/ui/addressForm/__index.utils'
import {
	numberMaxOfRequest,
	strapiDataRes,
	REQUEST_HIDDEN
} from '@pages/auth/requests/create/__index.utils'
import {
	IDENTIFIERS_OF_TN_REQUEST_TYPE,
	REQUESTS_IDS
} from '@services/constants'
import Modal from '@components/ui/modal'
import { eauLightGreyIcon, ecoResponsibilityIcon } from '@images/icons'
import axios from 'axios'
import { setRequestListStore } from '@services/store/requestList'
import { useAppDispatch } from '@services/store'
import RequestListCard from '@components/ui/requestSearch/RequestListCard'
import {
	removeApartmentNumber,
	removePostalCode
} from '@components/ui/incidentFormDetails/__details.utils'
import Notification from '@components/ui/notification'
import { logFrontendEvent } from '@services/logger/frontend-logging'

type PropertyProps = {}

const MyProperty: FC<PropertyProps> = () => {
	const {
		pageData,
		authUser,
		language,
		electedTeamMembers,
		electorialDistricts
	} = useContext(AppStateContext)
	const userInfo = authUser?.profile?.address
	const requestThemes = pageData?.collections?.requestThemes
	const isCityOfLaval =
		userInfo?.city === config.geolocation.MUNICIPALITY_ADDRESS.city &&
		userInfo.inMunicipality

	const [loading, setLoading] = useState<boolean>(false)
	const [loadingStrapi, setLoadingStrapi] = useState<boolean>(false)
	const [requestDeclarations, setRequestDeclarations] =
		useState<pageUtils.RequestDeclaration[]>()
	const [buildingRegistrationNumber, setBuildingRegistrationNumber] =
		useState<string>()
	const [buildingDistrict, setBuildingDistrict] = useState<string>()
	const [buildingElectedTeam, setBuildingElectedTeam] = useState<string>()
	const [districtAndElectedInfo, setDistrictAndElectedInfo] = useState<any>()
	const [loadingDistrictAndElectedInfo, setLoadingDistrictAndElectedInfo] =
		useState<boolean>(false)
	const [districtAndElectedInfoError, setDistrictAndElectedInfoError] =
		useState<string>()
	const [electedPersonDetails, setElectedPersonDetails] = useState<any>()
	const [loadingElectedPersonDetails, setLoadingElectedPersonDetails] =
		useState<boolean>(false)
	const [electedPersonDetailsError, setElectedPersonDetailsError] =
		useState<string>()
	const [requests, setRequests] = useState<Request[]>([])
	const [isOpenModal, setIsOpenModal] = useState<boolean>(false)
	const [openId, setOpenId] = useState<number | null>(null)

	const dispatch = useAppDispatch()

	const fetchRequests = async () => {
		if (authUser) {
			try {
				setLoading(true)
				const requestsList = await authUser.fetchRequests(false)
				setRequests(requestsList)
				// dispatch(
				// 	setRequestListStore({
				// 		fetching: false,
				// 		fetched: true,
				// 		requests: requestsList
				// 	})
				// )
			} catch (error: any) {
				console.error(error?.message)
			} finally {
				setTimeout(() => setLoading(false), 200)
			}
		}
	}

	const getRequestTitle = (value: string) => {
		let title = pageData.requests?.find(
			(request) => request.requestId == value
		)?.title

		if (!title) {
			title = pageData.requests?.find(
				(request) => request.requestId == 'other-subject'
			)?.title
		}

		return title
	}
	const getRequestDescripion = (value: string) => {
		let description = pageData.requests?.find(
			(request) => request.requestId == value
		)?.description

		if (!description) {
			description = pageData.requests?.find(
				(request) => request.requestId == 'other-subject'
			)?.description
		}

		return description
	}

	const sortRequestByTitle = (
		requestList: IDENTIFIERS_OF_TN_REQUEST_TYPE[]
	): IDENTIFIERS_OF_TN_REQUEST_TYPE[] => {
		const copy = [...requestList]
		copy.sort(function (a, b) {
			let aTitle = getRequestTitle(a)!
			let bTitle = getRequestTitle(b)!

			// Normalize the titles to remove accents and special characters
			const normalizedA = aTitle
				?.normalize('NFD')
				.replace(/[\u0300-\u036f]/g, '')
			const normalizedB = bTitle
				?.normalize('NFD')
				.replace(/[\u0300-\u036f]/g, '')

			if (normalizedA < normalizedB) {
				return -1
			}
			if (normalizedA > normalizedB) {
				return 1
			}
			return 0
		})

		return copy
	}

	const [statementRedirectOptionsList, setStatementRedirectOptionList] =
		useState(
			sortRequestByTitle([
				IDENTIFIERS_OF_TN_REQUEST_TYPE.OIL_HEATING_DECLARATION_FORM,
				IDENTIFIERS_OF_TN_REQUEST_TYPE.SELF_RELIEF_WATER_COUNTER_FORM,
				IDENTIFIERS_OF_TN_REQUEST_TYPE.FIREPLACE_DECLARATION
			])
		)

	const onNavigateToRequest = (id: string) => (e) => {
		e.preventDefault()
		const link: string = `${config.request.create.baseURL}/${id}`
		navigate(link)
	}

	useEffect(() => {
		setLoadingStrapi(true)
		axios
			.get(
				`${process.env.STRAPI_API}/api/ptc-requests?pagination%5BpageSize%5D=${numberMaxOfRequest}`
			)
			.then(async (res) => {
				const data = res.data as strapiDataRes
				const hiddenRequestList = data.data.map((request) => {
					if (REQUEST_HIDDEN[request.Cacher]) return request.request_id
				})

				setStatementRedirectOptionList(
					sortRequestByTitle(
						statementRedirectOptionsList.filter(
							(requestId) => !hiddenRequestList.includes(requestId)
						)
					)
				)
			})
			.catch((e) => {
				// setStatementRedirectOptionList([])
				console.error(e)
			})
			.finally(() => setLoadingStrapi(false))
	}, [])

	const getRequestIcon = (request) => {
		switch (request) {
			case IDENTIFIERS_OF_TN_REQUEST_TYPE.OIL_HEATING_DECLARATION_FORM:
			case IDENTIFIERS_OF_TN_REQUEST_TYPE.FIREPLACE_DECLARATION:
				return ecoResponsibilityIcon
			case IDENTIFIERS_OF_TN_REQUEST_TYPE.SELF_RELIEF_WATER_COUNTER_FORM:
				return eauLightGreyIcon

			default:
				return ecoResponsibilityIcon
		}
	}

	const displayStatementList = () => {
		return statementRedirectOptionsList.map((element) => (
			<div
				key={element}
				className={pageUtils.classes?.typeSelect}
				onClick={onNavigateToRequest(element)}
			>
				<Icon
					src={getRequestIcon(element)}
					className={pageUtils.classes?.iconStyle}
				/>
				<div>
					<span>{getRequestTitle(element)}</span>
					<p>{getRequestDescripion(element)}</p>
				</div>
			</div>
		))
	}

	useEffect(() => {
		fetchRequests().catch(console.error)
	}, [authUser])

	useEffect(() => {
		const requestDeclarationsGroup = ['declarations']
		const pageRequests = requestThemes
			?.map((theme) => {
				if (requestDeclarationsGroup.includes(theme.name)) {
					return theme.requests
				}
			})
			.filter((value) => value !== undefined)

		const requestData: pageUtils.RequestData[] =
			pageRequests?.flat() as pageUtils.RequestData[]

		const data = pageUtils.requestDeclarations(requestData, requests)
		setRequestDeclarations(data)
	}, [requests])

	const getDistrict = (id: string) => {
		const district = electorialDistricts?.find((district) => district.id == id)
		if (id.length < 2) {
			id = '0' + id
		}
		return `${id} - ${district?.place_name}`
	}

	const getElectedTeam = (id: string) => {
		if (id.length < 2) {
			id = '0' + id
		}

		const teamMember = electedTeamMembers?.find((electedTeam) =>
			electedTeam.name.startsWith(`District ${id}`)
		)

		if (teamMember) return teamMember.name.split('-')[1].trim()
	}

	const fetchDistrictAndElectedInfo = async (params: {
		Matricule?: string
		NoCivique?: string
		CodePostal?: string
		DistrictElectoral?: string
		CodeZone?: string
	}) => {
		setLoadingDistrictAndElectedInfo(true)
		setDistrictAndElectedInfoError(undefined)

		try {
			const response = await axios.get('/api/laval-search-adresse', {
				params
			})
			setDistrictAndElectedInfo(response?.data)
			return response?.data
		} catch (error: any) {
			setDistrictAndElectedInfo(undefined)
			setDistrictAndElectedInfoError(error?.message)
			console.error(error)
			return undefined
		} finally {
			setLoadingDistrictAndElectedInfo(false)
		}
	}

	const fetchElectedPersonDetails = async (params: {
		district?: string
		name?: string
	}) => {
		setLoadingElectedPersonDetails(true)
		setElectedPersonDetailsError(undefined)

		try {
			const electedPersonUrl =
				process.env.LAVAL_ELECTED_PERSON_URL ||
				'https://www.laval.ca/wp-json/address-search/elected-person'

			const response = await axios.get(electedPersonUrl, {
				params
			})
			setElectedPersonDetails(response?.data)

			// logFrontendEvent({
			// 	description: 'Elected person details loaded from frontend',
			// 	action: 'Load elected person details',
			// 	id: params?.district || 'my-property',
			// 	username: authUser?.profile?.email || '',
			// 	step: 'Success',
			// 	httpStatusCode: 200,
			// 	payload: {
			// 		district: params?.district,
			// 		name: params?.name
			// 	}
			// })

			return response?.data
		} catch (error: any) {
			setElectedPersonDetails(undefined)
			setElectedPersonDetailsError(error?.message)

			logFrontendEvent({
				description: 'Elected person details load failed from frontend',
				action: 'Load elected person Laval details',
				id: authUser?.profile?.id || 'my-property',
				username: authUser?.profile?.email || '',
				step: 'Error',
				httpStatusCode: error?.response?.status || '',
				payload: error?.message || 'Unknown error'
			})

			console.error(error)
			return undefined
		} finally {
			setLoadingElectedPersonDetails(false)
		}
	}

	useEffect(() => {
		// logFrontendEvent({
		// 	description: 'My Property page loaded',
		// 	action: 'Load my property page',
		// 	id: authUser?.profile?.email || 'my-property',
		// 	username: authUser?.profile?.email || '',
		// 	step: 'Starting',
		// 	payload: 'My Property initialization'
		// })


		if (
			isCityOfLaval &&
			userInfo?.coordinates &&
			!userInfo.hasAddressEnteredManually
		) {
			getAddressByCoordinates(userInfo?.coordinates)
				.then(async (res) => {
					const properties = res?.data?.features?.[0]?.properties

					const noCivique = (properties as any)?.no_civique ?? properties?.civic
					const codePostal =
						(properties as any)?.code_postal ?? properties?.postal_code
					const codeZone =
						(properties as any)?.collecte_id_zone ??
						properties?.collecte_id_zone
					setBuildingRegistrationNumber(properties?.matricule)
					const electedDistrictId = properties?.electoral_district_id

					const electedTeam = getElectedTeam(electedDistrictId)
					const district = getDistrict(electedDistrictId)
					setBuildingDistrict(district)
					setBuildingElectedTeam(electedTeam)

					const districtData = await fetchDistrictAndElectedInfo({
						Matricule: properties?.matricule,
						NoCivique: noCivique,
						CodePostal: codePostal,
						DistrictElectoral: properties?.electoral_district_id,
						CodeZone: codeZone
					})

					// if (districtData) {
					// 	logFrontendEvent({
					// 		description: 'District information loaded from frontend',
					// 		action: 'Load district info',
					// 		id: authUser?.profile?.id || 'my-property',
					// 		username: authUser?.profile?.email || '',
					// 		step: 'Success',
					// 		httpStatusCode: 200,
					// 		payload: {
					// 			Matricule: properties?.matricule,
					// 			NoCivique: noCivique,
					// 			CodePostal: codePostal,
					// 			DistrictElectoral: properties?.electoral_district_id,
					// 			CodeZone: codeZone
					// 		}
					// 	})
					// }

					const districtEluData = districtData?.elu
					if (districtEluData?.noDistrict && districtEluData?.nomConseil) {
						await fetchElectedPersonDetails({
							district: districtEluData?.noDistrict,
							name: districtEluData?.nomConseil
						})
					}
				})
				.catch((error) => {
					logFrontendEvent({
						description: 'Chargement de l\'information de l\'adresse Laval a échoué depuis le frontend',
						action: 'Load Search Address Laval info',
						id: authUser?.profile?.id || 'my-property',
						username: authUser?.profile?.email || '',
						step: 'Error',
						httpStatusCode: 500,
						payload: {
							error: error?.message
						}
					})
					console.error(error)
				})
		}
	}, [authUser, electorialDistricts])

	useEffect(() => {
		const sortedRequestList = sortRequestByTitle(statementRedirectOptionsList)
		setStatementRedirectOptionList(sortedRequestList)
	}, [language])

	const getRequestTheme = () => {
		return pageData.requests?.find(
			(request) =>
				request.requestId ==
				IDENTIFIERS_OF_TN_REQUEST_TYPE.MUNICIPAL_EVALUATION_FORM
		)
	}

	const onToggleCollapse = (next: boolean, id: number) => {
		setOpenId(next ? id : null)
	}

	const formatDateFr = (isoDate?: string) => {
		if (!isoDate) return ''

		const date = new Date(isoDate)
		if (Number.isNaN(date.getTime())) return ''

		return new Intl.DateTimeFormat('fr-CA', {
			day: 'numeric',
			month: 'long',
			year: 'numeric'
		}).format(date)
	}

	const formatWeekdayFr = (isoDate?: string) => {
		if (!isoDate) return ''

		const date = new Date(isoDate)
		if (Number.isNaN(date.getTime())) return ''

		return new Intl.DateTimeFormat('fr-CA', {
			weekday: 'long'
		}).format(date)
	}

	const capitalizeFirst = (value?: string) => {
		if (!value) return ''
		return value.charAt(0).toUpperCase() + value.slice(1)
	}

	// Destructure collecte types for easier access
	const collecteZone = districtAndElectedInfo?.collecte?.zone
	const dechet = districtAndElectedInfo?.collecte?.dechet || {}
	const organique = districtAndElectedInfo?.collecte?.organique || {}
	const recyclage = districtAndElectedInfo?.collecte?.recyclage || {}
	const encombrant = districtAndElectedInfo?.collecte?.encombrant || {}
	const districtElu = districtAndElectedInfo?.elu || {}

	// Extract image src from HTML picture tag
	const extractImageSrc = (htmlString: string | undefined): string => {
		if (!htmlString) return ''
		const srcMatch = htmlString.match(/src="([^"]*)"/)
		return srcMatch ? srcMatch[1] : ''
	}

	const electedPersonImage =
		extractImageSrc(electedPersonDetails?.picture) || ''
	const electedPersonProfileUrl = electedPersonDetails?.link || ''
	const electedPersonPopulation =
		electedPersonDetails?.district_population || ''
	const hasElectedPersonDetails =
		!loadingElectedPersonDetails &&
		!electedPersonDetailsError &&
		!!electedPersonDetails

	const getElectedPersonInitials = (fullName?: string) => {
		if (!fullName) return ''
		return fullName
			.split(' ')
			.filter(Boolean)
			.slice(0, 2)
			.map((part) => part.charAt(0).toUpperCase())
			.join('')
	}

	const electedPersonInitials = getElectedPersonInitials(
		districtElu?.nomConseil
	)

	const renderCollecteSupportLinks = () => (
		<div>
			<p style={{ marginBottom: '0.5rem' }}>
				Votre contenant n'est toujours pas ramassé quelques jours après la
				journée de collecte? Votre bac est brisé? Faites une demande au service
				:
				<ul style={{ paddingLeft: '20px', marginTop: '7px' }}>
					<li>
						<Link
							to={`${config.request.create.baseURL}/${REQUESTS_IDS.materialsOrWasteNotCollected}`}
							className={pageUtils.classes.link}
						>
							Signaler des matières ou déchets non ramassés
						</Link>
					</li>

					<li>
						<Link
							to={`${config.request.create.baseURL}/${REQUESTS_IDS.brokenBin}`}
							className={pageUtils.classes.link}
						>
							Signaler un bac brisé
						</Link>
					</li>
				</ul>
			</p>
		</div>
	)

	const renderCollecteEncombrantLinks = () => (
		<div>
			<p style={{ marginBottom: '0.5rem' }}>
				Vos encombrants n'ont pas été ramassés quelques jours après la journée
				de la collecte ? Faites une demande au service :
				<ul style={{ paddingLeft: '20px', marginTop: '7px' }}>
					<li>
						<Link
							to={`${config.request.create.baseURL}/${REQUESTS_IDS.materialsOrWasteNotCollected}`}
							className={pageUtils.classes.link}
						>
							Signaler des matières ou déchets non ramassés
						</Link>
					</li>
				</ul>
			</p>
		</div>
	)

	const renderDeclarations = () => {
		return (
			<section className={pageUtils.classes.section2}>
				<h3 className={pageUtils.classes.h3}>
					<Text content={pageData.assets?.page_myPropery_my_statements} />
				</h3>

				{loading ? (
					<Loader text={pageData?.assets?.loading} />
				) : (
					<>
						<div className={pageUtils.classes.collapse}>
							{requestDeclarations && !!requestDeclarations?.length ? (
								requestDeclarations.map((declaration) => (
									<Collapse
										id={1}
										buttonText={getRequestTitle(declaration.requestId) ?? ''}
										key={declaration.requestId}
										isOpen={false}
									>
										<div>
											<div className={pageUtils.classes.tableContainer}>
												<table className={pageUtils.classes.table}>
													<tbody>
														{declaration.requests.map((request) => (
															<tr
																className={pageUtils.classes.tableRow}
																key={request.id}
															>
																<td>
																	<b className={pageUtils.classes.rowHeader}>
																		{
																			pageData.assets
																				?.page_myPropery_declaration_date
																		}
																	</b>{' '}
																	<br />
																	{request.dateAdd?.localDateString}
																</td>

																<td>
																	<b className={pageUtils.classes.rowHeader}>
																		{
																			pageData.assets
																				?.request_form_declaration_adresse
																		}
																	</b>{' '}
																	<br />
																	{request.typeId ==
																		IDENTIFIERS_OF_TN_REQUEST_TYPE.SELF_RELIEF_WATER_COUNTER_FORM &&
																		removePostalCode(
																			removeApartmentNumber(
																				request.incidentForm?.declareAddress,
																				request.incidentForm?.declareAppartment
																			)
																		)}
																	{request.typeId ==
																		IDENTIFIERS_OF_TN_REQUEST_TYPE.OIL_HEATING_DECLARATION_FORM &&
																		request.incidentForm?.concernedInfo
																			?.address}
																	{request.typeId ==
																		IDENTIFIERS_OF_TN_REQUEST_TYPE.FIREPLACE_DECLARATION &&
																		request.incidentForm?.buildingAddress
																			?.address}
																</td>
																<td>
																	<b className={pageUtils.classes.rowHeader}>
																		{
																			pageData.assets
																				?.page_myPropery_request_number
																		}
																	</b>
																	<br />
																	<Link
																		to={request.link}
																		className={pageUtils.classes.link}
																	>
																		{request.code}
																	</Link>
																</td>
															</tr>
														))}
													</tbody>
												</table>
											</div>
										</div>
									</Collapse>
								))
							) : (
								<>
									<span>{pageData.assets?.label_no_declarations}</span>
								</>
							)}
						</div>
						<div>
							<div
								className={pageUtils.classes.button}
								onClick={() => setIsOpenModal(true)}
							>
								{pageData.assets?.page_myPropery_add_a_statement}
							</div>
						</div>
					</>
				)}
			</section>
		)
	}

	return (
		<>
			<div className={pageUtils.classes.row}>
				<div className={joinClasses([pageUtils.classes.small])}>
					<div className={pageUtils.classes.homeInfo}>
						<div className={pageUtils.classes.homeAddress}>
							<div className={pageUtils.classes.homeAddressInfo}>
								<div className={pageUtils.classes.homeIcon}>
									<Icon
										src={accueilDarkBlueV2}
										className={pageUtils.classes.homeImg}
									/>
								</div>

								<div style={{ marginTop: '.5rem' }}>
									<div className={pageUtils.classes.address}>
										{userInfo?.address}
										<br />
										{userInfo?.city} ({userInfo?.state}) {userInfo?.postalCode}
									</div>
									{/* {isCityOfLaval && !userInfo.hasAddressEnteredManually && (
									<div style={{ marginTop: '.5rem' }}>
										<div className={pageUtils.classes.matriclue}>
											{pageData.assets?.label_matricule}:&nbsp;
											<b>{buildingRegistrationNumber}</b>
										</div>
										<div className={pageUtils.classes.matriclue}>
											{pageData.assets?.label_district}:&nbsp;
											<b>{buildingDistrict ?? ''}</b>
										</div>
										<div className={pageUtils.classes.matriclue}>
											{pageData.assets?.label_elected}:&nbsp;
											<b>{buildingElectedTeam ?? ''}</b>
										</div>
									</div>
								)} */}
								</div>

								<Link
									to="/auth/profile"
									className={pageUtils.classes.link}
									onClick={() => {
										localStorage.setItem(config.localStorage.activeTab, '0')
									}}
								>
									{formatStrapiText(
										pageData.assets?.label_myProperty_update_my_address
									)}
								</Link>
							</div>

							{/* Search Laval Adresse */}
							{isCityOfLaval && !userInfo.hasAddressEnteredManually && (
								<div
									style={{ marginTop: '.5rem' }}
									className={pageUtils.classes.lavalSearchAdresseInfo}
								>
									{loadingDistrictAndElectedInfo ? (
										<Loader
											text={
												pageData?.assets?.fetching_address_search_laval_info
											}
										/>
									) : districtAndElectedInfoError ? (
										<div>
											<Notification
												type="error"
												text={
													pageData.assets
														?.error_fetching_address_search_laval_info
												}
												hasHtml
											/>
										</div>
									) : districtAndElectedInfo ? (
										<div
											style={{ marginTop: '-20px' }}
											className={pageUtils.classes.collapse}
										>
											<div>
												<Collapse
													id={1}
													buttonText="Arrosage"
													isOpen={openId === 1}
													useOnToggle
													onToggle={onToggleCollapse}
												>
													<p>
														Votre adresse est{' '}
														{districtAndElectedInfo?.horaireArrosage?.estPaire
															? 'paire'
															: 'impaire'}
													</p>
													<p>
														Vous êtes dans la zone d'arrosage :{' '}
														{districtAndElectedInfo?.horaireArrosage?.zone}
													</p>
													<p>
														Vous pouvez arroser votre jardin aux heures
														suivantes en fonction du moyen d'arrosage que vous
														utilisez.
													</p>
													<p>
														<b>Système non automatique</b>
													</p>
													<ul>
														{districtAndElectedInfo?.horaireArrosage?.nonAutomatique?.map(
															(item, index) => (
																<li key={index}>
																	{item.jour} : de {item.plageHoraire}
																</li>
															)
														)}
													</ul>
													<p>
														<b>Système automatique</b>
													</p>
													<ul>
														{districtAndElectedInfo?.horaireArrosage?.arrosageAutomatique?.map(
															(item, index) => (
																<li key={index}>
																	{item.jour} : de {item.plageHoraire}
																</li>
															)
														)}
													</ul>
													<p>
														<b>Boyau d'arrosage tenu à la main</b>
													</p>
													<p>Potager, fleurs et plates-bandes uniquement.</p>
													<ul>
														<li key={1}>
															{
																districtAndElectedInfo?.horaireArrosage?.manuel
																	?.jours
															}
															:
															{
																districtAndElectedInfo?.horaireArrosage?.manuel
																	?.plageHoraire
															}
														</li>
													</ul>
													<p>
														<b>Arrosoir à main</b>
													</p>
													<p>
														En tout temps : potager, fleurs et plates-bandes
														uniquement.
													</p>
												</Collapse>
												<Collapse
													id={2}
													buttonText={'Collecte des déchets'}
													isOpen={openId === 2}
													useOnToggle
													onToggle={onToggleCollapse}
												>
													<p>
														Vous résidez dans la zone de collecte {collecteZone}
														.
													</p>
													<p>
														<b>
															Votre prochaine collecte des déchets est le{' '}
															{formatWeekdayFr(dechet?.dateProchaineCollecte)}{' '}
															{formatDateFr(dechet?.dateProchaineCollecte)}.
														</b>
													</p>
													<p>
														Votre mode de collecte est : {dechet?.modeCollecte}
														{dechet?.position ? ` ${dechet.position}` : ''}.
													</p>
													{renderCollecteSupportLinks()}
												</Collapse>
												<Collapse
													id={3}
													buttonText={
														'Collecte des matières organiques (compostage)'
													}
													isOpen={openId === 3}
													useOnToggle
													onToggle={onToggleCollapse}
												>
													<p>
														Vous résidez dans la zone de collecte {collecteZone}
														.
													</p>
													<p>
														<b>
															Votre prochaine collecte des matières organiques
															est le{' '}
															{capitalizeFirst(
																formatWeekdayFr(
																	organique?.dateProchaineCollecte
																)
															)}{' '}
															{formatDateFr(organique?.dateProchaineCollecte)}.
														</b>
													</p>
													<p>
														Votre mode de collecte est :{' '}
														{organique?.modeCollecte}
														{organique?.position
															? ` ${organique.position}`
															: ''}
														.
													</p>
													{renderCollecteSupportLinks()}
												</Collapse>
												<Collapse
													id={4}
													buttonText={'Collecte de la récupération'}
													isOpen={openId === 4}
													useOnToggle
													onToggle={onToggleCollapse}
												>
													<p>
														Vous résidez dans la zone de collecte {collecteZone}
														.
													</p>
													<p>
														<b>
															Votre prochaine collecte de la récupération est le{' '}
															{capitalizeFirst(
																formatWeekdayFr(
																	recyclage?.dateProchaineCollecte
																)
															)}{' '}
															{formatDateFr(recyclage?.dateProchaineCollecte)}.
														</b>
													</p>
													<p>
														Votre mode de collecte est :{' '}
														{recyclage?.modeCollecte}
														{recyclage?.position
															? ` ${recyclage.position}`
															: ''}
														.
													</p>
													{renderCollecteSupportLinks()}
												</Collapse>
												<Collapse
													id={5}
													buttonText={'Encombrants'}
													isOpen={openId === 5}
													useOnToggle
													onToggle={onToggleCollapse}
												>
													<p>
														Vous résidez dans la zone de collecte {collecteZone}
														.
													</p>
													<p>
														<b>
															Votre prochaine collecte des encombrants est le{' '}
															{capitalizeFirst(
																formatWeekdayFr(
																	encombrant?.dateProchaineCollecte
																)
															)}{' '}
															{formatDateFr(encombrant?.dateProchaineCollecte)}.
														</b>
													</p>
												
													{renderCollecteEncombrantLinks()}
												</Collapse>
												<Collapse
													id={6}
													buttonText={'Personne élue'}
													isOpen={openId === 6}
													useOnToggle
													onToggle={onToggleCollapse}
												>
													{/* {loadingElectedPersonDetails && (
													<p>Chargement des details de la personne elue...</p>
												)}
												{!!electedPersonDetailsError && (
													<p>Erreur details elu: {electedPersonDetailsError}</p>
												)} */}
													<div
														className={pageUtils.classes.municipalCouncilorItem}
													>
														<div>
															{hasElectedPersonDetails && electedPersonImage ? (
																<img
																	// width="609"
																	// height="350"
																	src={electedPersonImage}
																	alt={`Portrait du conseiller municipal ${
																		districtElu?.nomConseil || ''
																	}`}
																	decoding="async"
																/>
															) : (
																<div>{electedPersonInitials}</div>
															)}
														</div>
														<div>
															<div>
																<h3>
																	District {districtElu?.noDistrict} -{' '}
																	{districtElu?.nomDistrict}
																</h3>
																{hasElectedPersonDetails &&
																	electedPersonPopulation && (
																		<span>
																			(Population : {electedPersonPopulation}
																			&nbsp;habitants)
																		</span>
																	)}
															</div>
															<h3>{districtElu?.nomConseil || ''}</h3>
															<p>
																{hasElectedPersonDetails &&
																	electedPersonProfileUrl && (
																		<a
																			id="hbs-elected-person-link"
																			href={electedPersonProfileUrl}
																			target="_blank"
																			rel="noopener noreferrer"
																		>
																			Voir son profil
																		</a>
																	)}
																<span>{districtElu?.telCell}</span>
																<a
																	href={
																		districtElu?.courriel
																			? `mailto:${districtElu?.courriel}`
																			: '#'
																	}
																	target="_blank"
																	rel="noopener noreferrer"
																>
																	Envoyer un courriel
																</a>
															</p>
														</div>
													</div>
												</Collapse>
											</div>
										</div>
									) : null}
								</div>
							)}
						</div>
					</div>
				</div>

				<div className={joinClasses([pageUtils.classes.large])}>
					<section
						className={joinClasses([
							pageUtils.classes.section2,
							pageUtils.classes.sectionWrapper
						])}
					>
						<h3
							className={pageUtils.classes.h3}
							style={{ marginBottom: '0px' }}
						>
							<Text
								content={
									pageData.assets?.page_myPropery_property_assessment_and_taxes
								}
							/>
						</h3>
						{getRequestTheme() && (
							<RequestListCard
								id={1}
								request={getRequestTheme()!}
								index={1}
								requestThemes={pageData?.collections?.requestThemes}
								hasParentGroup={false}
								isCardOpen={false}
							/>
						)}
					</section>

					{renderDeclarations()}
				</div>

				<Modal
					isOpen={isOpenModal !== false}
					showExitBtn
					title={pageData.assets?.page_myPropery_add_a_statement}
					onSetIsOpen={() => setIsOpenModal(false)}
					type={'default'}
				>
					<div className={pageUtils.classes?.modalContent}>
						{displayStatementList()}
					</div>
				</Modal>
			</div>
		</>
	)
}

export default MyProperty
